import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from 'firebase/firestore'
import { db } from '@/firebase'

const COL = 'products'

function normalizeProduct(p) {
  const price = Number(p.price)
  return {
    name: String(p.name || '').trim(),
    category: String(p.category || 'product').trim(),
    price: Number.isFinite(price) ? price : 0,
    isActive: p.isActive !== false,
    branchId: p.branchId || null,
    inventoryItemId: p.inventoryItemId || null,
    updatedAt: serverTimestamp(),
  }
}

export const productService = {
  async listByBranch(branchId) {
    const constraints = []
    if (branchId && branchId !== 'all-branches') {
      constraints.push(where('branchId', '==', branchId))
    }
    const q = query(collection(db, COL), ...constraints, orderBy('name', 'asc'))
    const snap = await getDocs(q)
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }))
  },

  async create(product) {
    const payload = {
      ...normalizeProduct(product),
      createdAt: serverTimestamp(),
    }
    const ref = await addDoc(collection(db, COL), payload)
    return ref.id
  },

  async update(id, patch) {
    const ref = doc(db, COL, id)
    await updateDoc(ref, normalizeProduct(patch))
  },

  async remove(id) {
    await deleteDoc(doc(db, COL, id))
  },
}

